<template>
    <div class="sidemenu">
        <router-link 
            :to="{path: 'strefa-rodzica'}" 
            class="sidemenu__item"
            :class="{'active': path === '/strefa-rodzica'}"
        >
            <IconProfile :status="{'active': path === '/strefa-rodzica'}"></IconProfile>
            <span class="sidemenu__item-name">Profil dziecka</span>
        </router-link>

        <router-link 
            :to="{path: 'ustawienia'}" 
            class="sidemenu__item"
            :class="{'active': path === '/ustawienia'}"
        >
            <IconSettings :status="{'active': path === '/ustawienia'}"></IconSettings>
            <span class="sidemenu__item-name">Ustawienia</span>
        </router-link>

        <!-- <router-link 
            :to="{path: 'prywatnosc'}" 
            class="sidemenu__item"
            :class="{'active': path === '/prywatnosc'}"
        >
            <IconPrivacy :status="{'active': path === '/prywatnosc'}"></IconPrivacy>
            <span class="sidemenu__item-name">Prywatność</span>
        </router-link> -->

        <router-link 
            :to="{path: 'konkursy'}" 
            class="sidemenu__item"
            :class="{'active': path === '/konkursy'}"
        >
            <IconCompetitions :status="{'active': path === '/konkursy'}"></IconCompetitions>
            <span class="sidemenu__item-name">Konkursy</span>
        </router-link>

        <router-link 
            :to="{path: 'opinie'}" 
            class="sidemenu__item"
            :class="{'active': path === '/opinie'}"
        >
            <IconOpinions :status="{'active': path === '/opinie'}"></IconOpinions>
            <span class="sidemenu__item-name">Opinie</span>
        </router-link>

        <router-link 
            :to="{path: 'faq'}" 
            class="sidemenu__item"
            :class="{'active': path === '/faq'}"
        >
            <IconFaq :status="{'active': path === '/faq'}"></IconFaq>
            <span class="sidemenu__item-name">FAQ</span>
        </router-link>
    </div>
</template>

<script>
import IconProfile from "../elements/icons/IconProfile.vue";
import IconSettings from "../elements/icons/IconSettings.vue";
// import IconPrivacy from "../elements/icons/IconPrivacy.vue";
import IconCompetitions from "../elements/icons/IconCompetitions.vue";
import IconOpinions from "../elements/icons/IconOpinions.vue";
import IconFaq from "../elements/icons/IconFaq.vue";

export default {
    name: "AccountSideMenu",
    components: {
        IconProfile,
        IconSettings,
        // IconPrivacy,
        IconCompetitions,
        IconOpinions,
        IconFaq
    },
    computed: {
        path() {
            return this.$route.path;
        }
    }
};
</script>